import { Component, OnInit } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { ViewChild } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { ClientEvent } from 'ngx-agora';
import { Stream } from 'ngx-agora';
import { AgoraClient } from 'ngx-agora';
import { NgxAgoraService } from 'ngx-agora';
import { StreamEvent } from 'ngx-agora';
import { UserDataService } from '../../remote/data-storage/user-data.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GlobalDataService } from '../../../shared-services/global-data.service';
import { AgoraRtmService } from '../services/agora-rtm.service';
import { MeetingService } from '../services/meeting.service';
import { Meeting } from '../../../dtos/meeting';
import * as moment from 'moment-timezone';
import { UserDto } from '../../../dtos/userDto';
import { UtilService } from '../../../shared-services/util.service';
import * as _ from 'lodash';
import { PanoramaImages } from '../../../dtos/panoramaImages';
import { HotSpot } from '../../../dtos/hotSpot';
import { Subscription } from 'rxjs/Subscription';
import { MeetingSyncVo } from '../../../vo/meeting-sync.vo';
import { MonumentDto } from '../../../dtos/monumentDto';
import { MonumentsDataService } from '../../remote/data-storage/monuments-data.service';
import { Observable } from 'rxjs/Observable';
import { GuideService } from '../services/guide.service';
import { FolderDto } from '../../../dtos/folderDto';
import swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedVo } from '../../../vo/shared.vo';
import { SiteDto } from '../../../dtos/siteDto';
import { SitesDataService } from '../../remote/data-storage/sites-data.service';
import { skipWhile } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import * as mapboxgl from 'mapbox-gl';
import { MapService } from '../../remote/map-page/map.service';
import { Subject } from 'rxjs';
import { GeoJson } from '../../../vo/geoJson';
import { skip } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-meeting-room',
    templateUrl: './meeting-room.component.html',
    styleUrls: ['./meeting-room.component.scss']
})
export class MeetingRoomComponent implements OnInit, OnDestroy, AfterViewInit {

    localCallId;
    remoteCalls: string[] = [];
    remoteCallsActions: any = {};
    /**
     * Whether the local client's A/V stream has been published to the remote meeting room
     */
    published = false;

    /**
     * Whether the local client has tuned in to the Agora meeting room
     */
    connected = false;

    @ViewChild("textSend")
    message: any;

    @ViewChild("chatBox")
    chatBox: any;

    @ViewChild('modalSave')
    private modalSave: TemplateRef<any>;

    receivedMessages = [];
    ownerName: string;
    panelsState = {
        "files": false,
        "cultureFiles": false,
        "message": false,
        "info": false,
        "users": false,
        "filters": false
    }
    meeting: Meeting;
    waitingMessage: string;
    availableToStartTour: boolean;
    ownerId: number;
    ordersUser: UserDto[];
    userName: string;
    actions = {
        video: true,
        microphone: true,
        hand: false
    }

    actionGuide = 'mouse';

    monumentView: any;
    channelName: string;
    waitingForGuide: boolean;
    waitingForGuideMessage: string;

    notifications: any = [];

    selectedPanorama: PanoramaImages;
    sitePanoramicHotspots: HotSpot[];
    selectedSite: SiteDto;
    selectedMonument: MonumentDto;
    flowLoading: boolean;
    monuments$: Observable<MonumentDto[]>;
    sites: SiteDto[];
    folder: FolderDto;
    selectedFolder: FolderDto;
    fileToShare: string;
    files: File[] = [];
    isMonumentOpen: boolean;
    historyObject = new SharedVo();
    step: number = 1;
    showIntro: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    private mapListeners = {
        sites: new Subject<SiteDto>(),
        monuments: new Subject()
    }

    private mapPopup = {
        sites: undefined,
        monuments: undefined
    };

    private map;
    private subscriptions: Subscription[] = [];
    private waitingGuideTimeout: any;
    private meetingCode;
    private client: AgoraClient;
    private localStream: Stream;

    constructor(private ngxAgoraService: NgxAgoraService, private userDataService: UserDataService,
                private router: Router, private translate: TranslateService,
                private route: ActivatedRoute,
                private agoraRtmService: AgoraRtmService, private meetingService: MeetingService,
                private utilService: UtilService,
                private monumentsDataService: MonumentsDataService,
                private sitesDataService: SitesDataService,
                public globalDataService: GlobalDataService,
                private guideService: GuideService,
                private modalService: NgbModal,
                private sanitizer: DomSanitizer,
                private mapService: MapService) {
    }

    ngOnInit(): void {
        this.showIntro.next(localStorage.getItem("introShow") === 'true');
        this.userName = this.userDataService.getUser().name;
        this.ownerId = this.userDataService.getUser().id;
        this.route.params.subscribe(params => {
            this.meetingCode = params['code'];
            if (this.meetingCode) {
                this.joinMeeting(this.meetingCode);
            } else if (!this.isOwner()) {
                this.router.navigate([this.globalDataService.getRemoteContext() + '/' + this.translate.currentLang + '/join-a-tour']);
            } else {
                // Init necessary variables for agora client
                this.channelName = 'meeting_' + Math.floor((Math.random() * 100000000000) + 1) + '';
                this.localCallId = this.channelName + '_local_' + this.ownerId;
                this.ownerName = this.userName;
                setTimeout(() => {
                    this.initAgoraClients();
                }, 100);
            }
        });

        const subscriptionTranslate =
            this.translate.onLangChange
                .subscribe(() => {
                    if (this.sitePanoramicHotspots) {
                        this.sitePanoramicHotspots = [...this.selectedPanorama.panoramaHotSpots];
                    }
                })
        this.mapListeners.sites.asObservable()
            .subscribe((data) => {
                this.selectedSite = this.sites.find((site) => site.id === data.id);
            })
        this.subscriptions.push(subscriptionTranslate);
        this.monuments$ = this.monumentsDataService.getAllMonumentData();
    }

    ngAfterViewInit(): void {
        this.sitesDataService.sites
            .subscribe((sites) => {
                if (sites.length > 0) {
                    this.sites = sites;
                    this.initMap(sites);
                }
            });

    }

    ngOnDestroy(): void {
        if (this.localStream) {
            this.localStream.close();
            this.leave();
            this.unpublish();
        }
    }

    selectSite(site) {
        this.selectedPanorama = site.panoramaImages.find((panorama) => panorama.natural);
        this.sitePanoramicHotspots = this.selectedPanorama.panoramaHotSpots;
    }

    joinMeeting(meetingCode) {
        this.syncFolder();
        this.meetingService.joinedMeetingCode(meetingCode).subscribe((meeting: Meeting) => {
            this.channelName = 'meeting_' + meeting.id;
            this.meeting = meeting;
            this.ordersUser = meeting.orderList.map((order) => order.user);
            this.ownerName = meeting.culturalRoute.user.name;
            this.localCallId = this.channelName + '_local_' + this.userDataService.getUser().id;
            //if someone trying to log in to a meeting that it shouldnt due to not starte and not owned by him
            if (!this.isOwner() && !meeting.started) {
                this.router.navigate([this.globalDataService.getRemoteContext() + '/' + this.translate.currentLang + '/join-a-tour/' + meetingCode]);
            }
            //if there is known logout issue
            if (meeting.guideLogout && !this.isOwner()) {
                this.waitingForGuide = true;
                const futureNoEntryDate = moment(this.meeting.guideLogout).tz('Europe/Athens').add(15, 'minutes').format();
                //start the timer above the Start the Meeting button
                this.waitingGuideTimeout = this.countDown(futureNoEntryDate, (distance) => {
                    this.waitingForGuideMessage = distance.minutes + ':' + distance.seconds;
                }, () => {
                    this.router.navigate([this.globalDataService.getRemoteContext() + '/' + this.translate.currentLang + '/join-a-tour']);
                });
            }
            //start the timer above the Start the Meeting button
            this.countDown(meeting.timestamp, this.waitingForStartButton.bind(this), this.clearWaitingForStartButton.bind(this));
            setTimeout(() => {
                this.initAgoraClients();
            }, 100);

        }, () => {
            this.router.navigate([this.globalDataService.getRemoteContext() + '/' + this.translate.currentLang + '/join-a-tour']);
        });
    }

    /**
     * Attempts to connect to an online chat room where users can host and receive A/V streams.
     */
    join(onSuccess?: (uid: number | string) => void, onFailure?: (error: Error) => void): void {
        this.client.join(null, this.channelName, this.userDataService.getUser().id, onSuccess, onFailure);
    }

    /**
     * Attempts to upload the created local A/V stream to a joined chat room.
     */
    publish(): void {
        this.client.publish(this.localStream, err => console.log('Publish local stream error: ' + err));
        setTimeout(() => {
            if (!this.isOwner()) {
                this.localStream.muteAudio();
            }
        }, 50)
    }

    unpublish(): void {
        this.client.unpublish(this.localStream, error => console.error(error));
        this.published = false;
    }

    sendMessage() {
        const message = this.message.nativeElement.value;
        if (!message.length) {
            return;
        }
        const messageObject = {name: this.userDataService.getUser().name, text: message, type: "CHAT_MESSAGE"};
        this.agoraRtmService.sendChannelMessage(JSON.stringify(messageObject), this.channelName).then(r => {
            this.receivedMessages.push(messageObject);
            setTimeout(() => {
                this.scrollToBottom(this.chatBox);
            }, 50);
            this.message.nativeElement.value = "";
        })
    }

    isOwner() {
        return this.userDataService.getUser().virtualTourType === 'GUIDE';
    }

    toggleMonument() {
        this.selectedMonument = null;
        this.monumentView = null;
    }

    toggleFile() {
        this.fileToShare = null;
    }

    newFolder() {
        swal({
            title: 'Enter folder name',
            input: 'text',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            preConfirm: (result) => {
                if (result.length <= 2) {
                    return Promise.reject("No valid name it must at least three characters long")
                } else {
                    return this.guideService.createFolder(this.selectedFolder.path, result)
                        .toPromise();
                }
            },
            allowOutsideClick: false
        }).then((result) => {
            if (result.value) {
                this.syncFolder(this.selectedFolder);
            }
        }, () => {
            swal("Folder already exists").then(() => {
                this.newFolder();
            });
        })
    }

    //Bottom actions
    raiseHand() {
        if (!this.actions.hand) {
            const messageObject = {user_id: this.userDataService.getUser().id, text: "", type: "RAISE_HAND"};
            this.agoraRtmService.sendChannelMessage(JSON.stringify(messageObject), this.channelName).then(r => {
                this.actions.hand = true;
            })
        }
    }

    turnOfCall() {
        this.router.navigate([this.globalDataService.getRemoteContext() + '/' + this.translate.currentLang + '/join-a-tour']);
    }

    toggleCamera() {
        if (this.actions.video) {
            this.localStream.muteVideo();
        } else {
            this.localStream.unmuteVideo();
        }
        this.actions.video = !this.actions.video;
        const messageObject = {
            name: this.userDataService.getUser().name,
            user_id: this.userDataService.getUser().id,
            text: '',
            type: 'CAMERA_TOGGLE'
        };
        this.agoraRtmService.sendChannelMessage(JSON.stringify(messageObject), this.channelName)
            .then(r => {
            });
    }

    toggleMicrophone() {
        if (this.actions.microphone) {
            this.localStream.muteAudio();
        } else {
            this.localStream.unmuteAudio();
        }
        this.actions.microphone = !this.actions.microphone;
    }

    shareScreen() {
        let syncObject = new MeetingSyncVo();
        syncObject.selectedPanoramaPosition = this.sendPanoramicPosition();
        syncObject.selectedMonumentIndex = this.sendMonumentIndex();
        syncObject.selectedFilePath = this.fileToShare;
        syncObject.selectedMonumentView = this.monumentView;
        /////History object/////////
        this.historyObject.selectedPanorama = _.cloneDeep(this.selectedPanorama);
        this.historyObject.sitePanoramicHotspots = _.cloneDeep(this.sitePanoramicHotspots);
        this.historyObject.fileToShare = _.cloneDeep(this.fileToShare);
        this.historyObject.monumentView = _.cloneDeep(this.monumentView);
        this.historyObject.selectedMonument = _.cloneDeep(this.selectedMonument);
        this.historyObject.isMonumentOpen = this.isMonumentOpen;
        /////end history object////
        const messageObject = {
            name: this.userDataService.getUser().name,
            user_id: this.userDataService.getUser().id,
            text: syncObject,
            type: 'SYNC_OBJECT'
        };
        this.agoraRtmService.sendChannelMessage(JSON.stringify(messageObject), this.channelName)
            .then(r => {
            });
    }

    ///End Bottom actions

    changePeriod(natural = false) {
        this.selectedPanorama = this.meeting.culturalRoute.site.panoramaImages.find((panorama) => panorama.natural === natural && panorama.mobile != natural);
        setTimeout(() => {
            this.sitePanoramicHotspots = [...this.selectedPanorama.panoramaHotSpots];
        })
    }

    openFolder(folder: FolderDto) {
        this.selectedFolder = folder;
    }

    openImage(file: String) {
        this.fileToShare = this.selectedFolder.path + '/' + file;
    }

    backToPreviousFolder() {
        const currentFolder = this.selectedFolder;
        const allFolderTree = this.folder;
        this.selectedFolder = this.utilService.locateParentFolder(allFolderTree, currentFolder);
    }

    syncFolder(currentFolder?: FolderDto) {
        this.guideService.getGuideFiles()
            .subscribe((folder) => {
                this.folder = folder;
                if (!currentFolder || currentFolder.path === folder.path) {
                    this.selectedFolder = folder;
                } else {
                    const parentFolder = this.utilService.locateParentFolder(folder, currentFolder);
                    this.selectedFolder = parentFolder.folderDtos.find((folder) => folder.path === currentFolder.path);
                }
            });
    }

    openUpload() {
        let modalRef = this.modalService.open(this.modalSave, {centered: true, size: 'lg'});
    }

    onSelectFile(event) {
        console.log(event);
        this.files.push(...event.addedFiles);
    }

    onRemoveFile(event) {
        console.log(event);
        this.files.splice(this.files.indexOf(event), 1);
    }

    saveFiles() {
        const formData = new FormData();
        for (let f of this.files) {
            formData.append("files", f);
        }
        formData.append("path", this.selectedFolder.path);
        this.guideService.uploadFiles(formData).subscribe(() => {
            this.files = [];
            this.syncFolder(this.selectedFolder);
        })
    }

    isImage(file) {
        return !file.includes('.pdf');
    }

    clickPoint($event) {

    }

    transformPdf(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url + '#toolbar=0&embedded=true');
    }

    openPanel(state) {
        const soloPanels = ["users", "message"];
        _.each(this.panelsState, (panel, key) => {
            if (key != state && !soloPanels.includes(key)) {
                this.panelsState[key] = false;
            } else if (soloPanels.includes(key)) {
                if (soloPanels.includes(state) && key != state) {
                    this.panelsState[key] = false;
                }
            }
        })
        this.panelsState[state] = !this.panelsState[state];
    }

    changeStep(step, component?) {
        if (step === 1) {
            this.selectedPanorama = null;
            this.step = step;
        } else if (step === 2) {
            this.selectSite(component);
            this.step = step;
        }
    }

    openHelp() {
        this.showIntro.next(true);
    }

    private sendPanoramicPosition() {
        return {x: this.selectedPanorama.rotateX, y: this.selectedPanorama.rotateY};
    }

    private sendMonumentIndex() {
        if (this.selectedMonument) {
            return this.selectedMonument.id;
        }
        return -1;
    }

    private initAgoraClients() {
        if (this.agoraRtmService.channels[this.channelName]) {
            this.agoraRtmService.channels[this.channelName].channel.on("ChannelMessage", this.channelMessages.bind(this))
        } else {
            this.agoraRtmService.initAgoraClients(this.channelName + '_local_' + this.userDataService.getUser().id, this.channelName)
                .then(() => {
                    this.agoraRtmService.channels[this.channelName].channel.on("ChannelMessage", this.channelMessages.bind(this))
                })
        }

        this.client = this.ngxAgoraService.createClient({mode: 'rtc', codec: 'h264'});
        this.assignClientHandlers();

        this.localStream = this.ngxAgoraService.createStream({streamID: this.userDataService.getUser().id, audio: true, video: true, screen: false});
        this.assignLocalStreamHandlers();
        // Join and publish methods added in this step
        this.initLocalStream(() => this.join(uid => this.publish(), error => console.error(error)));

    }

    private assignClientHandlers(): void {
        this.client.on(ClientEvent.LocalStreamPublished, evt => {
            this.published = true;
            console.log('Publish local stream successfully');
        });

        this.client.on(ClientEvent.Error, error => {
            console.log('Got error msg:', error.reason);
            if (error.reason === 'DYNAMIC_KEY_TIMEOUT') {
                this.client.renewChannelKey(
                    '',
                    () => console.log('Renewed the channel key successfully.'),
                    renewError => console.error('Renew channel key failed: ', renewError)
                );
            }
        });

        this.client.on(ClientEvent.RemoteStreamAdded, evt => {
            const stream = evt.stream as Stream;
            this.client.subscribe(stream, {audio: true, video: true}, err => {
                console.log('Subscribe stream failed', err);
            });
        });

        this.client.on(ClientEvent.RemoteStreamSubscribed, evt => {
            const stream = evt.stream as Stream;
            const id = this.getRemoteId(stream);
            if (!this.remoteCalls.includes(id)) {
                this.remoteCalls.push(id);
                this.remoteCallsActions[id] = {
                    hand: false,
                    video: true
                };
                setTimeout(() => stream.play(id), 1000);
                if (id === this.channelName + '_local_' + this.meeting.user.id) {
                    this.waitingForGuide = false;
                    if (this.waitingGuideTimeout) {
                        clearInterval(this.waitingGuideTimeout);
                    }
                }
            }
        });

        this.client.on(ClientEvent.RemoteStreamRemoved, evt => {
            const stream = evt.stream as Stream;
            if (stream) {
                stream.stop();
                this.remoteCalls = [];
                console.log(`Remote stream is removed ${stream.getId()}`);
            }
        });

        this.client.on(ClientEvent.PeerLeave, evt => {
            const stream = evt.stream as Stream;
            if (stream) {
                const remoteId = this.getRemoteId(stream);
                stream.stop();
                this.remoteCalls = this.remoteCalls.filter(call => call !== `${this.getRemoteId(stream)}`);
                console.log(`${evt.uid} left from this channel`);
                if (remoteId === this.channelName + '_local_' + this.meeting.user.id) {
                    this.meetingService.guideLoggedOut(this.meetingCode).subscribe();
                    this.waitingForGuide = true;
                    const futureNoEntryDate = moment().tz('Europe/Athens').add(15, 'minutes').format();
                    //start the timer above the Start the Meeting button
                    this.waitingGuideTimeout = this.countDown(futureNoEntryDate, (distance) => {
                        this.waitingForGuideMessage = distance.minutes + ':' + distance.seconds;
                    }, () => {
                        this.router.navigate([this.globalDataService.getRemoteContext() + '/' + this.translate.currentLang + '/join-a-tour']);
                    });
                }
            }
        });
    }

    leave(): void {
        if (this.connected) {
            this.client.leave(
                () => {
                    console.log('Left the channel successfully');
                    this.connected = false;
                    this.published = false;
                    this.remoteCalls = [];
                },
                err => {
                    console.log('Leave channel failed');
                }
            );
        } else {
            this.ngxAgoraService.AgoraRTC.Logger.warning('Local client is not connected to channel.');
        }
    }

    isStreamConnected(id) {
        return this.localCallId === id || this.remoteCalls.includes(id);
    }

    scrollToBottom(container): void {
        try {
            container.nativeElement.scrollTop = container.nativeElement.scrollHeight;
        } catch (err) {
        }
    }

    startTour() {
        this.availableToStartTour = false;
        this.meeting.started = true;
        this.meetingService.startMeeting(this.meetingCode).subscribe(() => {
            const messageObject = {name: this.userDataService.getUser().name, id: this.userDataService.getUser().id, text: '', type: 'INIT_TOUR'};
            this.agoraRtmService.sendChannelMessage(JSON.stringify(messageObject), this.channelName)
                .then(r => {
                });
        })
    }

    selectGuideAction(action) {
        this.actionGuide = action;
    }

    openMonument(monument, view?) {
        this.selectedMonument = null;
        this.isMonumentOpen = true;
        this.selectedMonument = monument;
        if (view) {
            setTimeout(() => {
                this.monumentView = view;
            })
        }
    }

    private assignLocalStreamHandlers(): void {
        this.localStream.on(StreamEvent.MediaAccessAllowed, () => {
            console.log('accessAllowed');
        });

        // The user has denied access to the camera and mic.
        this.localStream.on(StreamEvent.MediaAccessDenied, () => {
            console.log('accessDenied');
        });
    }

    private initLocalStream(onSuccess?: () => any): void {
        this.localStream.init(
            () => {
                // The user has granted access to the camera and mic.
                this.localStream.play(this.localCallId);
                this.connected = true;
                if (onSuccess) {
                    onSuccess();
                }
            },
            err => console.error('getUserMedia failed', err)
        );
    }

    private getRemoteId(stream: Stream): string {
        return `meeting_${this.meeting.id}_local_${stream.getId()}`;
    }

    private countDown(date: string, callBackCountDown: Function, callbackClearCountDown: Function) {

        // Update the count down every 1 second
        const x = setInterval(() => {

            const distance = this.utilService.calculateDistanceBetweenDates(date);

            callBackCountDown(distance);

            // If the count down is over, write some text
            if (distance.distance < 0) {
                clearInterval(x);
                callbackClearCountDown();
            }
        }, 1000);
        return x;
    }

    private waitingForStartButton(distance) {
        const pad = (n) => {
            return (n < 10 ? "0" + n : n);
        }
        // Output the result in an element with id="demo"
        this.waitingMessage = 'The tour will be start in ' + pad(distance.days) + "d " + pad(distance.hours) + "h "
            + pad(distance.minutes) + "m " + pad(distance.seconds) + "s ";
    }

    private clearWaitingForStartButton() {
        this.availableToStartTour = true;
        this.waitingMessage = 'You can start the tour anytime';
    }

    private channelMessages(...args) {
        //CAMERA_TOGGLE
        const messageObject = JSON.parse(args[0].text);
        switch (messageObject.type) {
            case "CHAT_MESSAGE":
                this.receivedMessages.push(messageObject);
                break;
            case "CAMERA_TOGGLE":
                this.remoteCallsActions[this.channelName + '_local_' + messageObject.user_id].video = !this.remoteCallsActions[this.channelName + '_local_' + messageObject.user_id].video;
                this.remoteCallsActions = _.cloneDeep(this.remoteCallsActions);
                break;
            case "RAISE_HAND":
                this.remoteCallsActions[this.channelName + '_local_' + messageObject.user_id].hand = true;
                this.remoteCallsActions = _.cloneDeep(this.remoteCallsActions);
                this.notifications.push({
                    id: this.channelName + '_local_' + messageObject.user_id,
                    user: this.ordersUser.find((user) => user.id === messageObject.user_id),
                    close: false
                })
                break;
            case "ACCEPT_HAND":
                if (messageObject.user_id === this.userDataService.getUser().id) {
                    this.localStream.unmuteAudio();
                }
                break;
            case "REMOVE_HAND":
                if (messageObject.user_id === this.userDataService.getUser().id) {
                    this.localStream.muteAudio();
                    this.actions.hand = false;
                }
                break;
            case "SYNC_OBJECT":
                const syncMeetingRoom: MeetingSyncVo = messageObject.text;
                this.selectedPanorama.rotateX = syncMeetingRoom.selectedPanoramaPosition.x;
                this.selectedPanorama.rotateY = syncMeetingRoom.selectedPanoramaPosition.y;
                this.fileToShare = syncMeetingRoom.selectedFilePath;
                if (syncMeetingRoom.selectedMonumentIndex > -1) {
                    this.openMonument(syncMeetingRoom.selectedMonumentIndex, syncMeetingRoom.selectedMonumentView);
                } else {
                    this.toggleMonument();
                }
                break;
        }

    }

    private initMap(sites) {
        this.map = this.mapService.clusterMap();
        this.map.on('load', () => {
            const divSite = document.getElementById('popUpWindow-sites');
            this.mapPopup.sites = new mapboxgl.Popup()
                .setDOMContent(divSite);
            this.addGeoJson("sites", sites);
            this.mapService.activateClusterLayer(this.map, "sites", ["sites", "monuments"]);
            this.mapService.mapLoadImage(this.map);
        });
    }

    private addGeoJson(name, data) {
        if (data.length > 0) {
            const geoJson = this.createGeoJson(data);
            this.mapService.addGeoJsonLayer(name, geoJson, this.mapListeners[name], this.mapPopup[name]);
        }
    }

    private createGeoJson(data) {
        const geoJson = new GeoJson();
        geoJson.type = "FeatureCollection";
        geoJson.features = data.map((el) => {
            const geoJSONObject = new GeoJson();
            geoJSONObject.type = "Feature";
            geoJSONObject.geometry = {
                type: "Point",
                coordinates: [el.longitude, el.latitude]
            };
            geoJSONObject.properties = el;
            return geoJSONObject;
        });
        return geoJson;
    }

}
